import { Component } from 'san';
import * as _ from 'lodash';

import { IRelativeTask } from 'src/models';
import { EConnectReceiptType, EReceiptCompleteType } from 'src/enums';
import relativeTaskService from 'src/services/relativeTask.service';
import { IRelativeTasksParams } from 'src/models/relativeTask';

export default class RelativeTask extends Component {
    static computed = {
        checkedTasks() {
            const relativeTasks = this.data.get('relativeTasks');
            const checkedTasks = _.filter(relativeTasks, { _is_checked: true });
            const checkedTasksCallback = this.data.get('checkedTasksCallback');
            if (checkedTasksCallback) {
                checkedTasksCallback(checkedTasks.length);
            }
            return checkedTasks;
        },
        isCheckedAll() {
            const relativeTasks = this.data.get('relativeTasks');
            const checkedTasks = _.filter(relativeTasks, { _is_checked: true });
            return checkedTasks.length > 0 && checkedTasks.length === relativeTasks.length;
        }
    }

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isDirty: boolean;
        editEnable: boolean;    // {{}}
        auditId: string;    // {{}}
        type: EReceiptCompleteType;    // {{}}
        relativeTasks: IRelativeTask[];
        relatedTasks: IRelativeTask[];
        checkedTasksCallback: (checkedTasksCount: number) => void;
        connectReceiptTypeEnum: any;
    } {
        return {
            isDirty: false,
            editEnable: true,
            auditId: '',
            type: EReceiptCompleteType.Completed,
            relativeTasks: [],
            relatedTasks: [],
            checkedTasksCallback: null,
            connectReceiptTypeEnum: EConnectReceiptType
        };
    }

    inited() {
        const auditId = this.data.get('auditId');
        const type = this.data.get('type');
        this.getTasks({
            audit_id: auditId,
            type
        });
    }

    //#region owner调用
    getDataSync(): { connected_audit_ids: string[] } {
        const checkedTasks: IRelativeTask[] = this.data.get('checkedTasks');
        return {
            connected_audit_ids: _.map(checkedTasks, 'audit_id')
        };
    }
    // 是否变更过
    getIsDirtySync(): boolean {
        return this.data.get('isDirty');
    }
    // 重置是否变更过
    resetIsDirtySync() {
        this.data.set('isDirty', false);
    }
    // 获取可关联回执、已关联回执
    getTasks(params: IRelativeTasksParams, checkedTasks?: IRelativeTask[]) {
        this.data.set('type', params.type);
        Promise.all([
            relativeTaskService.getRelativeTasks(params),
            relativeTaskService.getRelatedTasks(params)
        ]).then(results => {
            const relativeTasks: IRelativeTask[] = results[0];
            const relatedTasks: IRelativeTask[] = results[1];
            const relatedTaskProjectPuids: string[] = _.map(relatedTasks, 'project_puid');
            _.forEach(relativeTasks, relativeTask => {
                relativeTask._is_checked = _.includes(relatedTaskProjectPuids, relativeTask.project_puid);
            });
            let dataKey = 'relativeTasks';
            const oldRelativeTasks = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldRelativeTasks.length, ...relativeTasks]);
            dataKey = 'relatedTasks';
            const oldRelatedTasks = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldRelatedTasks.length, ...relatedTasks]);
            if (checkedTasks && checkedTasks.length) {
                this.checkTasks(checkedTasks);
            }
        });
    }
    // 更新关联回执
    // updateRelatedTasks(delay_end_time?: string): Promise<any> {
    //     const auditId = this.data.get('auditId');
    //     const type = this.data.get('type');
    //     const checkedTasks: IRelativeTask[] = this.data.get('checkedTasks');
    //     const data = {
    //         connected_audit_ids: _.map(checkedTasks, 'audit_id'),
    //         audit_id: auditId,
    //         type,
    //         delay_end_time
    //     };
    //     return relativeTaskService.updateRelatedTasks(data);
    // }
    //#endregion

    checkTask(task: IRelativeTask) {
        const relativeTasks: IRelativeTask[] = this.data.get('relativeTasks');
        const index: number = _.findIndex(relativeTasks, { project_puid: task.project_puid });
        task._is_checked = !task._is_checked;
        this.data.splice('relativeTasks', [index, 1, task]);
        this.data.set('isDirty', true);
    }

    checkTasks(tasks: IRelativeTask[]) {
        const relativeTasks: IRelativeTask[] = this.data.get('relativeTasks');
        _.forEach(relativeTasks, task => {
            if (_.find(tasks, { project_puid: task.project_puid })) {
                task._is_checked = true;
            }
        })
        this.data.splice('relativeTasks', [0, relativeTasks.length, ...relativeTasks]);
        this.data.set('isDirty', true);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        const relativeTasks = this.data.get('relativeTasks');
        _.forEach(relativeTasks, task => {
            task._is_checked = isCheckedAll;
        });
        this.data.splice('relativeTasks', [0, relativeTasks.length, ...relativeTasks]);
        this.data.set('isDirty', true);
    }

    goToDetail(task: IRelativeTask) {
        const href =  `/projects/${task.project_puid}`;
        window.open(href);
    }

    goToWorkCenterDetail(task: IRelativeTask) {
        const href =  `/works/workflow-receipt-audit/${task.audit_id}`;
        window.location.href = href;
    }
}